import React, { useState } from "react";
import { Breadcrumb, Button, Dropdown, Col } from "react-bootstrap";
import { FiUpload, FiPlus } from "react-icons/fi";
import AddLeaveModal from "../../../components/modals/hrm/employee/attendance/leaves/AddLeaveModal";
import EditLeaveModal from "../../../components/modals/hrm/employee/attendance/leaves/EditLeaveModal";
import DeleteLeaveModal from "../../../components/modals/hrm/employee/attendance/leaves/DeleteLeaveModal";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import LeavesStats from "../../../components/hrm/attendance/Leaves/LeavesStats";
import LeaveList from "../../../components/hrm/attendance/Leaves/LeaveList";

const initialLeaves = [
  {
    id: 1,
    name: "Anthony Lewis",
    role: "Finance",
    type: "Medical Leave",
    from: "14 Jan 2024",
    to: "15 Jan 2024",
    days: "2 Days",
    status: "Approved",
    img: "/assets/img/users/user-32-1.jpg",
  },
  {
    id: 2,
    name: "Brian Villalobos",
    role: "Developer",
    type: "Casual Leave",
    from: "21 Jan 2024",
    to: "25 Jan 2024",
    days: "5 Days",
    status: "Pending",
    img: "/assets/img/users/user-09.jpg",
  },
  {
    id: 3,
    name: "Emma Johnson",
    role: "HR",
    type: "Annual Leave",
    from: "04 Feb 2024",
    to: "08 Feb 2024",
    days: "5 Days",
    status: "Approved",
    img: "/assets/img/users/user-03.jpg",
  },
  {
    id: 4,
    name: "Sophia Kim",
    role: "Designer",
    type: "Unplanned Leave",
    from: "10 Mar 2024",
    to: "10 Mar 2024",
    days: "1 Days",
    status: "Pending",
    img: "/assets/img/users/user-05.jpg",
  },
];

const LeavesPage = () => {
  const [leaves, setLeaves] = useState(initialLeaves);
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [selectedLeave, setSelectedLeave] = useState(null);

  const leaveTypes = [
    "Medical Leave",
    "Casual Leave",
    "Annual Leave",
    "Unplanned Leave",
  ];

  const employeeOptions = Array.from(
    new Set(leaves.map((item) => item.name)),
  ).sort();

  const handleAddLeave = (newLeave) => {
    const nextId = leaves.length
      ? Math.max(...leaves.map((item) => item.id)) + 1
      : 1;
    setLeaves((prev) => [
      ...prev,
      {
        ...newLeave,
        id: nextId,
        img: "/assets/img/users/user-07.jpg",
        status: "Approved",
      },
    ]);
  };

  const handleUpdateLeave = (leave) => {
    setLeaves((prev) =>
      prev.map((item) => (item.id === leave.id ? leave : item)),
    );
  };

  const handleDeleteLeave = (leaveId) => {
    setLeaves((prev) => prev.filter((item) => item.id !== leaveId));
  };

  const openEditModal = (item) => {
    setSelectedLeave(item);
    setShowEdit(true);
  };

  const openDeleteModal = (item) => {
    setSelectedLeave(item);
    setShowDelete(true);
  };

  return (
    <>
      <div className="page-breadcrumb-container">
        <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb">
          {/* LEFT SIDE */}

          <Col md={4} sm={12}>
            <div className="my-auto mb-2">
              <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Leaves</h4>

              <Breadcrumb
                style={{
                  background: "transparent",
                  padding: 0,
                  margin: 0,
                  fontSize: "14px",
                }}
              >
                <Breadcrumb.Item>
                  <Link to="/">
                    <RiHome6Line
                      className="m text-dark"
                      style={{
                        fontSize: "1.2rem", // increased icon size
                        verticalAlign: "middle",
                      }}
                    />
                  </Link>
                </Breadcrumb.Item>

                <MdKeyboardArrowRight className="mt-1 fs-5" />

                <Breadcrumb.Item
                  linkAs="span"
                  className="text-dark text-decoration-none fs-6"
                >
                  Attendance
                </Breadcrumb.Item>

                <MdKeyboardArrowRight className="mt-1 fs-5" />

                <Breadcrumb.Item active>
                  <span className="text-dark fs-6">Leaves</span>
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
          </Col>

          {/* RIGHT SIDE */}
          <div className="d-flex align-items-center flex-wrap right-content">
            {/* EXPORT */}
            <Dropdown className="me-2 mb-2">
              <Dropdown.Toggle className="btn-white-custom">
                <FiUpload className="me-1" />
                Export
              </Dropdown.Toggle>

              <Dropdown.Menu align="end" className="dropdown-menu-custom">
                <Dropdown.Item>Export as PDF</Dropdown.Item>
                <Dropdown.Item>Export as Excel</Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>

            {/* ADD LEAVE */}
            <Button
              className="btn-primary-custom mb-2"
              onClick={() => setShowAdd(true)}
            >
              <FiPlus className="me-2" />
              Add Leave
            </Button>
          </div>
        </div>
        <LeavesStats data={leaves} />
        <LeaveList
          data={leaves}
          onEdit={openEditModal}
          onDelete={openDeleteModal}
        />
        <style>
          {`
               .page-breadcrumb-container {
  background: #f8f9fb;
  padding: 16px 20px;
  border-bottom: 1px solid #e5e7eb;
}

/* TITLE */
.page-title {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 4px;
  color: #111827;
}

/* BREADCRUMB */
.custom-breadcrumb {
  font-size: 13px;
  color: #6b7280;
  margin: 0;
}

.custom-breadcrumb .breadcrumb-item + .breadcrumb-item::before {
  content: ">";
  color: #9ca3af;
}

/* RIGHT SECTION */
.right-content {
  gap: 8px;
}

/* EXPORT BUTTON */
.btn-white-custom {
  background: #ffffff !important;
  border: 1px solid #e5e7eb !important;
  color: #111827 !important;
  font-size: 14px;
  display: flex;
  align-items: center;
  padding: 6px 14px;
  border-radius: 6px;
}

/* ADD LEAVE BUTTON */
.btn-primary-custom {
  background-color: #f97316 !important;
  border: none !important;
  font-size: 14px;
  display: flex;
  align-items: center;
  padding: 6px 14px;
  border-radius: 6px;
}

/* DROPDOWN */
.dropdown-menu-custom {
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}

/* MOBILE RESPONSIVE */
@media (max-width: 768px) {
  .page-breadcrumb {
    flex-direction: column;
    align-items: flex-start !important;
  }

  .right-content {
    width: 100%;
    margin-top: 10px;
    justify-content: flex-start;
  }

  .btn-primary-custom,
  .btn-white-custom {
    width: 100%;
    justify-content: center;
  }
}`}
        </style>
      </div>

      {/* MODALS */}
      <AddLeaveModal
        show={showAdd}
        handleClose={() => setShowAdd(false)}
        onSave={handleAddLeave}
        employeeOptions={employeeOptions}
        leaveTypes={leaveTypes}
      />

      <EditLeaveModal
        show={showEdit}
        handleClose={() => setShowEdit(false)}
        onSave={handleUpdateLeave}
        data={selectedLeave}
        employeeOptions={employeeOptions}
        leaveTypes={leaveTypes}
      />

      <DeleteLeaveModal
        show={showDelete}
        handleClose={() => setShowDelete(false)}
        data={selectedLeave}
        onDelete={(id) => {
          handleDeleteLeave(id);
          setShowDelete(false);
        }}
      />
    </>
  );
};

export default LeavesPage;
